import { render, staticRenderFns } from "./WidgetSales.vue?vue&type=template&id=434967ec"
import script from "./WidgetSales.vue?vue&type=script&lang=js"
export * from "./WidgetSales.vue?vue&type=script&lang=js"
import style0 from "./WidgetSales.vue?vue&type=style&index=0&id=434967ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports